module.exports = __webpack_public_path__ + "static/apple-icon-120x120-e695b5efeca385336a6842ac1cc846bd.png";